export interface CommonGlobal {
	registerLogging: (registerFunc: (enable: boolean) => void) => void;
	enableLogging: (enable: boolean) => void;
	websocketStats: () => object;
}

export const commonGlobal = globalThis as unknown as CommonGlobal;
